package nl.volleyplanner.web.base.component

import kotlinx.html.*
import kotlinx.html.stream.createHTML

fun FlowContent.tooltipAttributes(cssClasses: Set<String> = emptySet(),  titleLabel: String? = null, block: (TagConsumer<*>.() -> Unit)? = null) {
    val finalCssClasses = mutableSetOf<String>().apply { addAll(cssClasses) }
    attributes["data-bs-toggle"] = "tooltip"
    if (titleLabel != null) {
        if (titleLabel.length > 100) {
            finalCssClasses += "vp-tooltip-lg"
        } else if (titleLabel.length > 70) {
            finalCssClasses += "vp-tooltip-md"
        }
        attributes["data-bs-title"] = titleLabel
    } else {
        attributes["data-bs-html"] = "true"
        attributes["data-bs-title"] = createHTML(false).apply(block!!).finalize()
    }
    if (finalCssClasses.isNotEmpty()) {
        attributes["data-bs-custom-class"] = finalCssClasses.joinToString(" ")
    }
}